// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo_Logo_2A07e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 71
// module chunks = 3